
import { mapGetters } from "vuex";

export default {
  props: {
    isSelected: { type: Boolean, default: false },
    name: { type: String, required: true },
    image: { type: Object, required: true },
  },

  computed: {
    ...mapGetters("bedbuilder", ["showOptionsModalOpen"]),
    showOptionImage() {
      return !this.showOptionsModalOpen;
    },
    imgProps() {
      return {
        src: this.image.url,
        alt: this.image.alt,
        height: 75,
        width: 75,
        provider: "ipx",
      };
    },
  },

  methods: {
    onOptionCardClick(e) {
      e.stopPropagation();
      this.$store.dispatch("bedbuilder/setActiveOption", this.name);
    },
  },
};
